<template>
    <div>
        <v-dialog v-model="optiondialog" max-width="500px">
            <template v-slot:activator="{ on }">
                <v-btn color="primary" dark class="mb-4" v-on="on">+</v-btn>
            </template>
            <v-card>
                <v-card-title class="subtitle-1 blue--text">{{ $t('pmformsetup.selectsectiontype') }}</v-card-title>
                <v-card-text>
                    <v-list>
                        <v-list-item v-for="option in sections" :key="option.value" @click="handleOptionClick(option)"
                            class="bordered-list-item">
                            <v-list-item-content>{{ option.text }}</v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-dialog v-model="sectiondialog" max-width="900px">
            <v-card>
                <v-card-title>
                    <span class="headline mb-4">
                        {{ isEdit ? ((sections.find(s => s.value === formData.pmsectiontypeid) && sections.find(s => s.value === formData.pmsectiontypeid).text) || '') + ' - ' + formData.sectname : $t('Setupformsetup.addnewsection') }}
                    </span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <!-- first row -->
                        <v-row>
                            <v-col cols="5" sm="5" class="pb-n4 mt-n8">
                                <v-autocomplete outlined :label="$t('columns.section')" :items="sections"
                                    item-text="text" item-value="value" v-model="formData.pmsectiontypeid" dense
                                    readonly background-color="#ffeab2" class="v-input"></v-autocomplete>
                            </v-col>

                            <v-col cols="5" sm="5" class="pb-n4 mt-n8">
                                <v-text-field outlined :label="$t('columns.sectionname')" type="text"
                                    :rules="[rules.required]" v-model="formData.sectname" dense
                                    class="v-input"></v-text-field>
                            </v-col>

                            <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                                <v-text-field outlined :label="$t('Setupformreviewsectiondetails.order')" type="number"
                                    :rules="[rules.required, rules.integer]" v-model="formData.orderno" dense
                                    class="v-input"></v-text-field>
                            </v-col>
                        </v-row>
                        <!-- end of first row -->
                        <!-- cover whole column and row -->
                        <v-row>
                            <v-col cols="12" class="pb-n4 mt-n8">
                                <v-textarea v-model="formData.description" outlined :label="$t('columns.description')"
                                    type="textarea" :rules="[rules.required]" dense rows="2" class="v-input"
                                    style="resize: vertical;"></v-textarea>
                            </v-col>
                        </v-row>
                        <!-- end of whole column and row -->
                        <!-- third row -->
                        <v-row v-if="isObjective || isScorable">
                            <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                                <v-text-field outlined :label="$t('pmformsetup.sectionweightage')" type="number"
                                    :rules="[rules.required, rules.positivemax100]" v-model="formData.sectweightage"
                                    dense class="v-input"></v-text-field>
                            </v-col>
                            <v-col v-if="formData.formtype === 'G'" cols="2" sm="2" class="pb-n4 mt-n8">
                                <v-autocomplete outlined :label="$t('Setupformreviewsection.dimension')"
                                    :items="dimensionList" item-text="text" item-value="value" :rules="[rules.required]"
                                    v-model="formData.dimension" dense class="v-input"></v-autocomplete>
                            </v-col>
                            <!-- <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                                <v-text-field outlined :label="$t('pmformsetup.maxscore')" type="number"
                                    :rules="[rules.positiveNumber]" v-model="formData.maxscore" dense
                                    class="v-input"></v-text-field>
                            </v-col> -->
                            <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                                <v-text-field outlined :label="$t('pmformsetup.sectiondivider')" type="number"
                                    :rules="[rules.required, rules.positiveNumber]" v-model="formData.sectdivider" dense
                                    class="v-input"></v-text-field>
                            </v-col>
                            <v-col v-if="isObjective" cols="4" sm="4" class="pb-n4 mt-n8">
                                <v-autocomplete outlined :label="$t('pmformsetup.achievementtoratingmapset')"
                                    :items="ratingSetList" item-text="text" item-value="value" :rules="[rules.required]"
                                    v-model="formData.ratingset" dense class="v-input"></v-autocomplete>
                            </v-col>
                            <v-col v-if="isScorable" cols="4" sm="4" class="pb-n4 mt-n8">
                                <v-autocomplete outlined :label="$t('pmformsetup.computationethod')"
                                    :items="computationMethodList" item-text="text" item-value="value"
                                    :rules="[rules.required]" v-model="formData.computationmethod" dense
                                    class="v-input"></v-autocomplete>
                            </v-col>
                            <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                                <v-checkbox outlined ref="changeWeightage" v-model="formData.changeWeightage"
                                    :label="$t('Setupformreviewsectiondetails.changeweightage')" dense></v-checkbox>
                            </v-col>
                        </v-row>
                        <!-- end of third row -->
                        <!-- last row -->
                        <v-row>
                            <!-- <v-col v-if="isObjective || isScorable" cols="4" sm="4" class="pb-n4 mt-n8">
                                <v-autocomplete outlined :label="$t('pmformsetup.weightingunit')"
                                    :items="weightingUnitList" item-text="text" item-value="value"
                                    :rules="[rules.required]" v-model="formData.weightingunit" dense
                                    class="v-input"></v-autocomplete>
                            </v-col> -->
                            <v-col cols="6" sm="6" class="pb-n4 mt-n8">
                                <v-autocomplete outlined :label="$t('Setupformreviewsection.displayoption')"
                                    :items="displayOptionList" item-text="text" item-value="value"
                                    :rules="[rules.required]" v-model="formData.pmdisplayoptionid" dense
                                    class="v-input"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row v-if="isScorable">
                            <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                <v-autocomplete outlined :label="$t('pmkpiset.calmethod')"
                                    :items="calcMethodList" hide-selected item-text="text" item-value="value"
                                    :rules="[rules.required]" v-model="formData.calcmethod" dense
                                    class="v-input"></v-autocomplete>
                            </v-col>
                        </v-row>
                        <!-- end of last row -->
                        <!-- Scorable Row -->
                        <v-row>
                            <v-col v-if="isScorable" cols="12" class="pb-n4 mt-n8">
                                <v-radio-group v-model="formData.scorabletype" :rules="[rules.required]" row @change="onScorableTypeChange">
                                    <v-radio :label="$t('pmformsetup.useratingset')" value="1"></v-radio>
                                    <v-radio :label="$t('pmformsetup.useminmaxrating')" value="2"></v-radio>
                                </v-radio-group>
                            </v-col>
                        </v-row>
                        <!-- Rating Set -->
                        <v-row v-if="formData.scorabletype == '1' && isScorable">
                            <v-col cols="7" sm="7" class="pb-n4 mt-n8">
                                <v-autocomplete outlined :label="$t('Setupratingset.ratingset')" :items="ratingSetList"
                                    item-text="text" item-value="value" :rules="[rules.required]"
                                    v-model="formData.ratingset" dense @change="updateRatingSetCode"
                                    class="v-input"></v-autocomplete>
                            </v-col>
                            <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                                <v-text-field outlined :label="$t('Setupratingset.ratingsetdescription')"
                                    v-model="formData.ratingsettext" dense readonly background-color="#ffeab2"
                                    class="v-input"></v-text-field>
                            </v-col>
                        </v-row>
                        <!-- Min Max Rating -->
                        <v-row v-if="formData.scorabletype == '2' && isScorable">
                            <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                <v-text-field outlined type="number" :label="$t('pmformsetup.minrating')"
                                    :rules="allowDecimalRules" v-model="formData.minrating" dense
                                    class="v-input"></v-text-field>
                            </v-col>
                            <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                                <v-text-field outlined type="number" :label="$t('pmformsetup.maxrating')"
                                    :rules="allowDecimalRules" v-model="formData.maxrating" dense
                                    class="v-input"></v-text-field>
                            </v-col>
                            <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                                <v-checkbox outlined ref="allowDecimal" v-model="formData.allowDecimal"
                                    :label="$t('pmformsetup.allowdecimal')" dense></v-checkbox>
                            </v-col>
                        </v-row>
                        <!-- End of Min Max Rating -->
                        <v-row v-if="formData.scorabletype && isScorable">
                            <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                                <v-text-field outlined :label="$t('pmformsetup.itemdivider')" type="number"
                                    :rules="[rules.positiveNumber]" v-model="formData.itemdivider" dense
                                    class="v-input"></v-text-field>
                            </v-col>
                            <!-- Comment because no more in use -->
                            <!-- <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                                <v-text-field outlined :label="$t('pmformsetup.itemweightage')" type="number"
                                    :rules="[rules.positivemax100]" v-model="formData.itemweightage" dense
                                    class="v-input"></v-text-field>
                            </v-col> -->
                        </v-row>
                    </v-container>
                </v-card-text>

                <v-card-text v-if="isErr" class="mt-n12">
                    <span style="font-weight: bold; color: red">{{ errMsg }}</span>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="saveSectionInput">{{ $t('button.save') }}</v-btn>
                    <v-btn color="red darken-1" text @click="closeSectionDialog">{{ $t('button.cancel') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-container class="overflow-y-auto">
            <v-row>
                <v-cols cols="12">
                    <v-data-table v-if="!loading" :headers="this.parentObject.tabHeader" :items="detailItem"
                        class="elavation-1" fixed-header :sort-by="['code']">
                        <template v-slot:[`item.action`]="{ item }">
                            <div class="d-flex align-center">
                                <img :src="`${publicPath}images/paper.svg`" alt="SVG Icon"
                                    @click="onAdvanceEditItem(item)" style="width: 15px; height: 18px; cursor: pointer;"
                                    class="mb-1" />
                                <v-icon small class="ml-2 mr-2" @click="modifyItemHandler(item)">
                                    mdi-pen
                                </v-icon>
                                <v-icon small class="mr-2" @click="deleteItemHandler(item)">
                                    mdi-delete
                                </v-icon>
                            </div>
                        </template>

                        <div v-if="isErr">
                            <app-error v-bind:parentError="{
                                data: this.errMsg,
                                isErr: this.isErr,
                            }" v-on:closeError="isErr = $event" />
                        </div>

                    </v-data-table>
                </v-cols>
            </v-row>
        </v-container>
    </div>
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                integer: value =>
                    (Number.isInteger(Number(value)) && value >= 0) || this.$t('reportsparam.nonnegativeInteger'),
                positiveintmax100: value => {
                    const num = Number(value);
                    return (Number.isInteger(num) && num >= 0 && num <= 100)
                        ? true
                        : this.$t('reportsparam.integer0to100');
                },
                positivemax100: value => {
                    const num = Number(value);
                    return (num >= 0 && num <= 100)
                        ? true
                        : this.$t('reportsparam.number0to100');
                },
                positiveNumber: value => {
                    const num = Number(value);
                    return (num > 0) || this.$t('reportsparam.positiveNumber');
                }
            },

            publicPath: process.env.BASE_URL,

            optiondialog: false,
            sectiondialog: false,
            //Loading for List of Form Sections
            loading: true,

            //Lists
            sections: this.parentObject.sectionTypeList,
            // weightingUnitList: [
            //     { text: this.$t('columns.percentage'), value: 'P' },
            //     { text: this.$t('columns.number'), value: 'N' },
            // ],
            computationMethodList: [
                { text: this.$t('pmformsetup.standardformula'), value: 1 },
            ],
            dimensionList: [
                { text: 'X', value: 'X' },
                { text: 'Y', value: 'Y' },
            ],
            ratingSet: [],
            ratingSetList: [],
            displayOption: [],
            displayOptionList: [],
            detailItem: [],

            //Section checks
            isObjective: false,
            isScorable: false,
            isComments: false,
            isTR: false,
            isMR: false,

            formData: {
                pmsectiontypeid: null,
                pmsectiontypedesc: null,
                sectdivider: 1,
                pmreviewformid: this.parentObject.pmreviewformid,
                sectname: null,
                orderno: null,
                description: null,
                sectweightage: null,
                dimension: null,
                ratingset: null,
                ratingsettext: null,
                calcmethod: null,
                computationmethod: null,
                pmdisplayoptionid: null,
                changeWeightage: false,
                formtype: this.parentObject.formtype,
                scorabletype: "1",
                allowDecimal: false,
                itemdivider: null,
                rectimestamp: null,
                updatedby: null,
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            isEdit: false,

            //error msg and dialog, check for duplicates vars
            isErr: false,
            errMsg: '',

            calcMethodList: [
                { text: this.$t('pmreviewexercise.method1'), value: 1 }, //All Items
                { text: this.$t('pmreviewexercise.method2'), value: 2 } //Reviewed Items Only
            ],
        }
    },

    computed: {
        allowDecimalRules() {
            return this.formData.allowDecimal
                ? [this.rules.positivemax100]
                : [this.rules.positiveintmax100];
        }
    },

    methods: {
        onScorableTypeChange(value) {

            if (value === '1') {//Rating Set
                this.formData.minrating = null;
                this.formData.maxrating = null;
                this.formData.allowDecimal = false;
            } else if (value === '2') {//Min-Max Rating
                this.formData.ratingset = null;
                this.formData.ratingsettext = '';
            }

            this.formData.itemdivider = null;
        },

        onAdvanceEditItem(item) {
            this.$router.push({ name: "formsetupeditsectionitem", params: { id: item.id, reviewform: this.parentObject.reviewform, section: item } });
        },

        async loadReviewFormSection() {
            const vm = this;

            try {
                const res = await this.$store.dispatch('get', { url: "/reviewformsection/" + this.formData.pmreviewformid });

                vm.detailItem = res.data.rec.map(item => {
                    const sectionType = vm.sections.find(type => type.value === item.pmsectiontypeid);
                    const displayOptionType = vm.displayOptionList.find(type => type.value === item.pmdisplayoptionid);

                    return {
                        ...item,
                        pmsectiontype: sectionType.text,
                        pmdisplayoptiontext: displayOptionType.text
                    };
                });
            } catch (err) {
                vm.isErr = !vm.isErr;
                vm.errMsg = err;
            }
        },

        handleOptionClick(option) {
            this.resetSelections();
            this.formData.pmsectiontypedesc = option.text;
            this.optiondialog = false;
            this.formData.pmsectiontypeid = option.value;
            switch (option.value) {
                case 1:
                    this.isObjective = true;
                    break;
                case 2:
                    this.isScorable = true;
                    this.formData.itemdivider = 1;
                    break;
                case 3:
                    this.isComments = true;
                    break;
                case 4:
                    this.isTR = true;
                    break;
                case 5:
                    this.isMR = true;
                    break;
            }

            this.sectiondialog = true;
        },

        updateRatingSetCode(value) {
            const selectedRatingSet = this.ratingSetList.find(item => item.value === value);
            if (selectedRatingSet) {
                this.formData.ratingsettext = selectedRatingSet.text;
            } else {
                this.formData.ratingsettext = ''; // Clear the text if no match is found
            }
        },

        loadRatingSet() {
            const vm = this;
            this.$store.dispatch('get', { url: "/ratingset/active/all" })
                .then(function (res) {
                    vm.ratingSet = res.data.rec;

                    for (let i = 0; i < vm.ratingSet.length; i++) {
                        vm.ratingSetList.push({
                            text: vm.ratingSet[i].rateset,
                            value: vm.ratingSet[i].id,
                        });
                    }
                })
                .catch(function (err) {
                    vm.errMsg = err;
                });
        },

        loadDisplayOption() {
            const vm = this;

            return this.$store.dispatch('get', { url: "/reviewform/displayoption/all" })
                .then(function (res) {
                    vm.displayOption = res.data.rec;

                    for (let i = 0; i < vm.displayOption.length; i++) {
                        vm.displayOptionList.push({
                            text: vm.displayOption[i].description,
                            value: vm.displayOption[i].id,
                        });
                    }
                })
                .catch(function (err) {
                    vm.errMsg = err;
                    console.error("Error loading display options:", err);
                });
        },


        modifyItemHandler(item) {
            this.resetSelections();
            this.isEdit = true;
            this.formData.pmsectiontypedesc = item.pmsectiontype;

            switch (item.pmsectiontypeid) {
                case 1:
                    this.isObjective = true;
                    break;
                case 2:
                    this.isScorable = true;
                    this.formData.itemdivider = 1;
                    break;
                case 3:
                    this.isComments = true;
                    break;
                case 4:
                    this.isTR = true;
                    break;
                case 5:
                    this.isMR = true;
                    break;
            }

            this.formData = item;
            if (this.formData.scorabletype != null){
                this.formData.scorabletype = String(this.formData.scorabletype);
            }
            this.updateRatingSetCode(item.ratingset);
            this.sectiondialog = true;
        },

        deleteItemHandler(item) {
            const vm = this;

            if (!this.CheckPermission(this.$route.meta.funcname, "candelete")) {
                return false;
            }

            if (confirm(this.$t('pmformsetup.deletesection', { section: item.sectname }))) {
                this.$store.dispatch('delete', { url: "/reviewformsection/" + item.id })
                    .then(function () {
                        const index = vm.detailItem.findIndex(detail => detail.id === item.id);
                        if (index !== -1) {
                            vm.detailItem.splice(index, 1);
                        }
                    })
                    .catch(function (err) {
                        vm.errMsg = err;
                    });
            }
        },

        saveSectionInput() {
            const vm = this;

            if (this.isEdit) {//Edit
                if (!this.CheckPermission(this.$route.meta.funcname, "canedit")) {
                    return false;
                }

                this.$store.dispatch('put', { url: "/reviewformsection/" + this.formData.id, payload: this.formData })
                    .then((res) => {
                        if (res.data.error) {
                            vm.isErr = !vm.isErr;
                            if (Array.isArray(res.data.error)) {
                                vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                            } else {
                                vm.errMsg = res.data.error;
                            }
                        } else {
                            const index = this.detailItem.findIndex(item => item.id === this.formData.id);
                            if (index !== -1) {
                                const displayOptionType = vm.displayOptionList.find(type => type.value === this.formData.pmdisplayoptionid);

                                this.detailItem[index].pmsectiontype = this.formData.pmsectiontypedesc;
                                this.detailItem[index].pmdisplayoptiontext = displayOptionType.text;
                                this.detailItem[index] = { ...this.formData };
                            }
                            this.sectiondialog = false;
                            this.isEdit = false;
                            this.resetSelections();
                        }
                    })
                    .catch((err) => {
                        vm.isErr = !vm.isErr;
                        vm.errMsg = err;
                        console.log("err", err);
                    });
            } else { //Add
                if (!this.CheckPermission(this.$route.meta.funcname, "canadd")) {
                    return false;
                }

                this.$store.dispatch('post', { url: "/reviewformsection/create", payload: this.formData })
                    .then((res) => {
                        if (res.data.error) {
                            vm.isErr = !vm.isErr;
                            if (Array.isArray(res.data.error)) {
                                vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                            } else {
                                vm.errMsg = res.data.error;
                            }
                        } else {
                            const displayOptionType = vm.displayOptionList.find(type => type.value === res.data.result.pmdisplayoptionid);

                            res.data.result.pmsectiontype = res.data.result.pmsectiontypedesc;
                            res.data.result.pmdisplayoptiontext = displayOptionType.text;

                            this.detailItem.push(res.data.result);
                            this.sectiondialog = false;
                            this.resetSelections();
                        }
                    })
                    .catch((err) => {
                        vm.isErr = !vm.isErr;
                        vm.errMsg = err;
                        console.log("err", err);
                    });
            }
        },

        closeSectionDialog() {
            this.sectiondialog = false;
            this.isErr = false;

            // reset the form fields
            this.resetSelections();
            if (this.isEdit == false) {
                this.optiondialog = true;
            }
            this.isEdit = false;
        },

        resetSelections() {
            this.isObjective = false,
                this.isScorable = false,
                this.isComments = false,
                this.isTR = false,
                this.isMR = false,
                this.formData = {
                    pmsectiontypeid: null,
                    pmsectiontypedesc: null,
                    sectdivider: 1,
                    pmreviewformid: this.parentObject.pmreviewformid,
                    sectname: null,
                    orderno: null,
                    description: null,
                    sectweightage: null,
                    dimension: null,
                    ratingset: null,
                    ratingsettext: null,
                    calcmethod: null,
                    computationmethod: null,
                    pmdisplayoptionid: null,
                    changeWeightage: false,
                    formtype: this.parentObject.formtype,
                    scorabletype: "1",
                    allowDecimal: false,
                    itemdivider: null,
                    rectimestamp: null,
                    updatedby: null,
                    stamp: 0,
                    userid: this.$store.getters.userId,
                }
        },
    },

    mounted() {
        this.loadRatingSet();

        Promise.all([this.loadDisplayOption()])
            .then(() => {
                // After loading dependencies, load review form section
                return this.loadReviewFormSection();
            })
            .then(() => {
                // Once everything is loaded, set loading to false
                this.loading = false;
            })
            .catch((err) => {
                // Handle any errors that occur during the process
                this.isErr = true;
                this.errMsg = err;
                console.error("Error:", err);
            });
    }
}
</script>

<style>
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-outer-spin-button,
.v-input .v-input__control .v-input__slot .v-text-field__slot input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
</style>

<style scoped>
.bordered-list-item {
    border: 1px solid #ccc;
    /* Light gray border */
    border-radius: 4px;
    /* Rounded corners */
    margin-bottom: 8px;
    /* Space between items */
    padding: 6px;
    /* Inner padding */
    transition: border-color 0.3s ease;
}

.bordered-list-item:hover {
    border-color: #1976d2;
    /* Change border color on hover (Vuetify primary color) */
}
</style>